// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.objProp {
    border: 1px solid lightgray;
    border-radius: 4px;
    margin: 2px 0px;
    padding: 2px;
}

.outerCell {
    min-width: 180px;
}

.innerCell {
    width: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/reltoobject/reltoobject.object.settings.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".objProp {\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    margin: 2px 0px;\n    padding: 2px;\n}\n\n.outerCell {\n    min-width: 180px;\n}\n\n.innerCell {\n    width: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
